import React from 'react';
import { ItemContainer, ItemContent, DragHandle, ActionButton, PermissionConfigName } from './styles';
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { UserPermissionConfig } from '../../redux/features/user/types';
import { Tooltip } from 'antd';

interface PermissionItemProps {
    permission: UserPermissionConfig;
    onEdit: () => void;
    onDelete: (id: string) => void;
}

const PermissionItem: React.FC<PermissionItemProps> = ({
    permission,
    onEdit,
    onDelete,
}) => {
    return (
        <ItemContainer>
            <ItemContent>
                <DragHandle>⋮⋮</DragHandle>
                <Tooltip placement="topLeft" title={permission.configName} style={{ width: '100%', minWidth: 0 }}>
                    <PermissionConfigName>{permission.configName}</PermissionConfigName>
                </Tooltip>
            </ItemContent>
            <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
                <ActionButton onClick={onEdit}>
                    <EditOutlined />
                </ActionButton>
                <ActionButton type='link' danger onClick={() => onDelete(permission.id)}>
                    <DeleteOutlined />
                </ActionButton>
            </div>
        </ItemContainer>
    );
};

export default PermissionItem; 